import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles({
  dBlock: {
    display: 'block',
  },
  mR10: {
    marginRight: '10px',
  },
  mT10: {
    marginTop: '10px',
  },
  mT5: {
    marginTop: '5px',
  },
  mT0: {
    marginTop: '0px',
  },
  mT20: {
    marginTop: '20px',
  },
  mTB20: {
    marginTop: '20px',
    marginBottom: '20px',
  },
  mB10: {
    marginBottom: '10px',
  },
  mpT0: {
    marginTop: '20',
    paddingTop: '0',
  },
  mpB0: {
    marginBottom: '0',
    paddingBottom: '0',
  },
  mpTB0: {
    marginTop: '0 !important',
    PaddingTop: '0 !important',
    paddingBottom: '0 !important',
  },
  padd20: {
    padding: '20px',
  },
  cancelButton: {
    marginLeft: '10px',
  },
  enableScroll: {
    overflow: 'auto',
    scrollBehavior: 'smooth',
    maxHeight: '600px',
  },
  btn: {
    backgroundColor: '#0A688D',
    color: '#fff',

    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },
  btn2: {
    backgroundColor: '#797979',
    color: '#fff !important',
    padding: '6px 32px !important',
    disabled: true,
    pointerEvents: 'none',
    cursor: 'default',
    zIndex: '999',
    '&:hover': {
      backgroundColor: '#797979',
    },
  },
  mp0: {
    margin: '0 !important',
    padding: '0 !important',
  },
  modalViewHeight: {
    height: '70vh',
  },
  editAcitonBtn: {
    position: 'absolute',
    width: '100%',
    bottom: '0',
    left: '0',
    borderTop: '1px solid #ccc',
    background: '#fff',
    zIndex: '999',
  },
  mB50: {
    marginBottom: '50px',
  },
  mB80: {
    marginBottom: '80px',
  },
  customDatepicker: {
    width: '100%',
    '& > div': {
      width: '100%',
    },
  },
  customLableTxt: {
    width: '100%',
    '& > label': {
      lineHeight: '15px',
    },
  },
  lableViewMrg: {
    margin: '15px 0px -15px 0px',
  },
  lableViewMrg10: {
    margin: '10px 0px -10px 0px',
  },
  error: {
    color: 'red',
  },
  buttonMargin: {
    marginLeft: '10px',
  },
  buttonActions: {
    width: '100%',
    bottom: '0',
    left: '0',
    borderTop: '1px solid #ccc',
    background: '#fff',
    zIndex: '999',
  },
  mt: {
    marginTop: '10px',
  },
  mb: {
    marginBottom: '10px',
  },
  dialogHeight: {
    overflowY: 'visible',
  },
  discardDialogHeight: {
    height: '180px',
  },
  dialogContentBox: {
    overflowY: 'visible',
  },
  dialogContent: {
    display: 'flex',
    justifyContent: 'left',
  },
  discardDialogContent: {
    display: 'flex',
    justifyContent: 'left',
    marginTop: '20px',
  },
  userProfileBtn: {
    width: '100%',
    bottom: '0',
    left: '0',
    borderTop: '1px solid #ccc',
    background: '#fff',
    zIndex: '999',
  },
  dialogTitle: {
    backgroundColor: '#0A688D',
    color: '#FFF',
  },
  fieldset: {
    width: '100%',
    marginBottom: 10,
    padding: 10,
    border: '1px solid #ddd',
    borderRadius: 5,
    marginTop: '10px',
  },
  modalWidth: {
    minWidth: '950px',
  },
})
